export class Workout
{
    Name: string | null = null;
    Intervals: Array<Interval> = [];
}

export class Interval
{
    Name: string | null = null;
    TotalSeconds: number = 0;
    TargetCadence?: number = undefined;
    TargetPower?: number = undefined;
    TargetPowerVariation?: Array<number> = undefined;

    constructor(name: string | null, totalSeconds: number, targetCadence?: number, targetPower?: number, targetPowerVariation?: Array<number>)
    {
        this.Name = name;
        this.TotalSeconds = totalSeconds;
        this.TargetCadence = targetCadence;
        this.TargetPower = targetPower;
        this.TargetPowerVariation = targetPowerVariation;
    }

    public GetTargetPowerAtTime(secondsSinceBeginningOfTheInterval: number): number | undefined
    {
        if (this.TargetPower !== undefined) return this.TargetPower;
        if (this.TargetPowerVariation === undefined) return undefined;

        let value = this.Lerp(this.TargetPowerVariation[0], this.TargetPowerVariation[1], secondsSinceBeginningOfTheInterval / this.TotalSeconds);
        return Math.round(value);
    }

    Lerp(min: number, max: number, factor: number) : number
    {
        return min + (max - min) * factor;
    }
}